// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__16nWC","title":"Widget_title__2xIdN"};